import React from 'react';
import PageNavigationBar from '@client/shared-components/PageNavigationBar';

import { HelpIconWithFaqDialog } from '@client/shared-components/HelpIconWithFaqDialog';
export const Header: React.FC = () => {
  const helpIcon = <HelpIconWithFaqDialog />;

  return <PageNavigationBar iconRight={helpIcon} />;
};
